export const instrumentationSchema = {
  scenario: [{
    name: 'auctionInsight',
    value: 'auctionInsight',
    setting: {},
    activity: [
      {
        name: 'loadInsightAuctionInsightPage',
        value: 'loadInsightAuctionInsightPage',
      },
      {
        name: 'auctionInsightFeedback',
        value: 'auctionInsightFeedback',
      },
      {
        name: 'userAction',
        value: 'userAction',
      },
    ],
  }],
};
